import { UserOutlined } from '@ant-design/icons'
import { Typography } from 'antd'
import { Avatar } from 'antd'
import cls from 'classnames'
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'

export interface MentionUser {
  email: string
  avatar: string
  name: string
  departments: { id: number; name: string }[]
}

export interface MentionListProps {
  items: MentionUser[]
  command: (_: any) => void
}

export const MentionList = forwardRef((props: MentionListProps, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const selectItem = (index: number) => {
    const item = props.items[index]
    if (item) {
      props.command({ id: item.email.split('@')[0], label: item.name })
    }
  }

  const upHandler = () => {
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length)
  }

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length)
  }

  const enterHandler = () => {
    selectItem(selectedIndex)
  }

  useEffect(() => setSelectedIndex(0), [props.items])

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }: any) => {
      if (event.key === 'ArrowUp') {
        upHandler()
        return true
      }
      if (event.key === 'ArrowDown') {
        downHandler()
        return true
      }
      if (event.key === 'Enter') {
        enterHandler()
        return true
      }
      return false
    },
  }))

  const content = props.items.map((u, index) => (
    <div
      key={u.email}
      className={cls('flex px-8px py-8px', {
        'bg-true-gray-100': index === selectedIndex,
      })}
      onClick={() => selectItem(index)}
    >
      <div className='flex items-center'>
        <Avatar className='flex-shrink-0 mr-8px' src={u.avatar} icon={<UserOutlined />} />
      </div>
      <div className='leading-tight text-xs'>
        <div>{u.name}</div>
        <Typography.Text type='secondary'>{u.departments.map((d) => d.name).join(',')}</Typography.Text>
      </div>
    </div>
  ))

  return (
    <div className='ant-popover ant-popover-placement-bottom !pt-0 w-180px'>
      <div className='ant-popover-content'>
        <div className='ant-popover-arrow'>
          <span className='ant-popover-arrow-content'></span>
        </div>
        <div className='ant-popover-inner'>{content}</div>
      </div>
    </div>
  )
})
